var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAngleRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "fill",
    width: 9,
    height: 16,
    viewBox: "0 0 7 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.220589 0.229521C0.150744 0.302092 0.0953307 0.388304 0.0575208 0.483218C0.019711 0.578133 0.000248879 0.679885 0.000248875 0.782646C0.00024887 0.885407 0.019711 0.987159 0.0575208 1.08207C0.0953307 1.17699 0.150744 1.2632 0.220589 1.33577L4.19109 5.47015L0.220589 9.60452C0.0797587 9.75122 0.000641865 9.95018 0.000641856 10.1576C0.000641847 10.3651 0.0797587 10.5641 0.220589 10.7108C0.361419 10.8575 0.552425 10.9399 0.751589 10.9399C0.950752 10.9399 1.14176 10.8575 1.28259 10.7108L5.78259 6.02327C5.85243 5.9507 5.90785 5.86449 5.94566 5.76957C5.98347 5.67466 6.00293 5.57291 6.00293 5.47015C6.00293 5.36738 5.98347 5.26563 5.94566 5.17072C5.90785 5.0758 5.85243 4.98959 5.78259 4.91702L1.28259 0.229521C1.21292 0.156766 1.13016 0.0990424 1.03904 0.0596573C0.947922 0.0202722 0.85024 -2.25231e-07 0.751589 -2.29543e-07C0.652938 -2.33856e-07 0.555257 0.0202722 0.464139 0.0596573C0.373022 0.0990424 0.290257 0.156766 0.220589 0.229521Z",
    fill: "#0B2640"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleRight);
export default __webpack_public_path__ + "static/media/angle-right.d0419fa024de39a5ab2dd84585726421.svg";
export { ForwardRef as ReactComponent };